import { cn } from "../lib/utils";
import { Slot } from "@radix-ui/react-slot";
import type { FC, InputHTMLAttributes } from "react";

type VariantItemProps = InputHTMLAttributes<HTMLInputElement> & {
  inputName?: string;
  children?: React.ReactNode;
};

const VariantItem: FC<VariantItemProps> = ({ children, ...props }) => (
  <label className={cn("relative box-border block h-7 w-7 cursor-pointer")}>
    <input
      type="radio"
      id={props.id}
      name={props.inputName}
      value={props.id}
      onChange={props.onChange}
      className={cn("peer absolute cursor-pointer opacity-0")}
      {...props}
    />
    <Slot
      className={cn(
        "absolute inset-0",
        "rounded-full",
        "shadow-[0_0_0_1px_gray-4/60]",
        "border-2 border-white",
        "outline-gray-border outline-[0.5px]",
        "peer-checked:outline-1 peer-hover:outline-1 peer-active:outline-1",
        "peer-hover:outline-gray-4 peer-active:outline-gray-4 peer-checked:outline-gray-4",
        "transition-colors",
      )}
    >
      {children}
    </Slot>
  </label>
);

export { VariantItem };
